import { Node, mergeAttributes } from '@tiptap/core'

/**
 * PageBreak Extension
 *
 * Creates a custom node that forces a page break in the document.
 * Usage: Press Ctrl+Enter (Cmd+Enter on Mac) or use editor.commands.setPageBreak()
 */
export const PageBreak = Node.create({
  name: 'pageBreak',

  group: 'block',

  parseHTML() {
    return [
      {
        tag: 'div[data-type="page-break"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'page-break',
        class: 'page-break',
      }),
      [
        'div',
        { class: 'page-break-line' },
      ],
      [
        'span',
        { class: 'page-break-text' },
        'Page Break',
      ],
    ]
  },

  addCommands() {
    return {
      setPageBreak:
        () =>
        ({ commands }) => {
          return commands.insertContent({ type: this.name })
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => this.editor.commands.setPageBreak(),
    }
  },
})
